import { render, staticRenderFns } from "./discountsProduct.vue?vue&type=template&id=6edd3fb4&scoped=true"
import script from "./discountsProduct.vue?vue&type=script&lang=ts"
export * from "./discountsProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd3fb4",
  null
  
)

export default component.exports